/**
 * benvel-account-bridge.js — Mi Benvel account bridge page (Story 17.1)
 *
 * Defensive localStorage reader for wishlist product + look counts.
 * Populates the summary-strip tile values on DOMContentLoaded.
 *
 * Keys (Story 14.1 localStorage contract):
 *   benvel.wishlist.products — array of saved product IDs
 *   benvel.wishlist.looks    — array of saved look IDs
 *
 * Graceful empty: if key is missing, count returns 0 (no throw, no broken markup).
 * JS-disabled clients: counts remain 0 (set in Liquid placeholder) — page is functional.
 *
 * No SRA, no /cart/add.js, no analytics emission, no fetch. IIFE; no globals.
 */
(function () {
  'use strict';

  /**
   * Reads a JSON array from localStorage and returns its length.
   * Returns 0 on any error (missing key, invalid JSON, SecurityError, etc.).
   * @param {string} key
   * @returns {number}
   */
  function readCount(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return 0;
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.length : 0;
    } catch (_e) {
      return 0;
    }
  }

  function updateCounts() {
    var productsCount = readCount('benvel.wishlist.products');
    var looksCount = readCount('benvel.wishlist.looks');

    var productEls = document.querySelectorAll('[data-bv-wishlist-products-count]');
    var looksEls = document.querySelectorAll('[data-bv-wishlist-looks-count]');

    for (var i = 0; i < productEls.length; i++) {
      productEls[i].textContent = productsCount;
    }
    for (var j = 0; j < looksEls.length; j++) {
      looksEls[j].textContent = looksCount;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCounts);
  } else {
    updateCounts();
  }
})();

/* === fit-profile-panel === */
/**
 * Fit profile CTA click handler — Story 17.3
 *
 * Primary CTA targets the size-guide modal (Epic 20, D17.3.2 default).
 * Graceful degradation: if the size-guide modal (`data-bv-size-guide-modal`)
 * is not yet in the DOM (Epic 20 not yet shipped), the CTA falls back to
 * its default `href="/pages/guia-de-tallas"` (standard link navigation).
 *
 * No analytics emission. No PII logging. Habeas Data Ley 1581/2012.
 */
(function () {
  'use strict';

  function wireFitProfileCtas() {
    var updateCtas = document.querySelectorAll('[data-bv-fit-profile-cta-update]');
    var startCtas = document.querySelectorAll('[data-bv-fit-profile-cta-start]');
    var allCtas = Array.prototype.slice.call(updateCtas).concat(Array.prototype.slice.call(startCtas));

    for (var i = 0; i < allCtas.length; i++) {
      allCtas[i].addEventListener('click', function (event) {
        var modal = document.querySelector('[data-bv-size-guide-modal]');
        if (modal) {
          event.preventDefault();
          /* Fire custom event for size-guide modal to open (Epic 20 wiring) */
          modal.dispatchEvent(new CustomEvent('benvel:size-guide-open', {
            bubbles: true,
            detail: { source: 'fit-profile-panel' }
          }));
        }
        /* else: fall through to href="/pages/guia-de-tallas" */
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireFitProfileCtas);
  } else {
    wireFitProfileCtas();
  }
})();
/* === /fit-profile-panel === */
